import {
  __decorateClass
} from "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/token-icon/token-icon.element.ts
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Task } from "@lit/task";

// libs/widgets/src/lib/token-icon/repositories/index.ts
var repositories = [
  () => import("./one-inch.repository-AF3TE4XT.js").then((m) => m.oneInchRepository),
  () => import("./uniswap.repository-MXTOGC4T.js").then((m) => m.uniSwapRepository),
  () => import("./trustwallet.repository-P6G45YEI.js").then((m) => m.trustWalletRepository),
  // () => import('./sushiswap.repository').then(m => m.sushiSwapRepository),
  () => import("./pancakeswap.repository-LI7PUPCX.js").then((m) => m.pancakeSwapRepository)
];

// libs/widgets/src/lib/token-icon/token-icon.element.ts
import { ChainId } from "@one-inch-community/models";
import { getWrapperNativeToken, isNativeToken } from "@one-inch-community/sdk/chain";
import { consume } from "@lit/context";
import { ApplicationContextToken } from "@one-inch-community/core/application-context";
var TokenIconElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.size = 24;
    this.task = new Task(this, {
      task: ([symbol, address, chainId], { signal }) => {
        return this.iconLoader(signal, chainId, symbol, address);
      },
      args: () => [this.symbol, this.address, this.chainId]
    });
  }
  render() {
    return this.task.render({
      error: () => symbolView(this.size, this.symbol),
      pending: () => symbolView(this.size, this.symbol, true),
      initial: () => symbolView(this.size, this.symbol, true),
      complete: (value) => {
        value.width = this.size;
        value.height = this.size;
        value.ondragstart = () => false;
        return html`${value}`;
      }
    });
  }
  updated() {
    this.style.width = `${this.size}px`;
    this.style.height = `${this.size}px`;
  }
  async iconLoader(signal, chainId, symbol, address) {
    let result = await this.loadFromDatabase({ chainId, symbol, address, signal });
    if (result === null) {
      result = await loadFromRepository({ chainId, symbol, address, signal });
    }
    if (result === null) {
      result = await this.loadIconFromMultiChain({ chainId, symbol, address, signal });
    }
    if (result === null) {
      throw new Error("token icon not fount");
    }
    return result;
  }
  async loadFromDatabase(data) {
    if (!data.chainId || !data.address) {
      return null;
    }
    const logoURL = await this.applicationContext.tokenController.getTokenLogoURL(data.chainId, data.address);
    if (!logoURL) {
      return null;
    }
    return await new Promise((resolve) => {
      const img = new Image();
      img.onerror = () => resolve(null);
      img.onload = () => resolve(img);
      img.src = logoURL;
    });
  }
  async loadIconFromMultiChain(data) {
    if (data.chainId === ChainId.eth || !data.symbol) return null;
    const tokens = await this.applicationContext.tokenController.getTokenBySymbol(ChainId.eth, data.symbol);
    if (data.chainId && data.address && isNativeToken(data.address)) {
      const wrapToken = getWrapperNativeToken(data.chainId);
      tokens.push(wrapToken);
    }
    for (const token of tokens) {
      const result = await loadFromRepository({ ...data, chainId: token.chainId, address: token.address });
      if (result) return result;
    }
    return null;
  }
};
TokenIconElement.tagName = "inch-token-icon";
TokenIconElement.styles = css`

      :host {
          user-select: none;
          outline: none;
          -webkit-user-select: none;
          -webkit-tap-highlight-color: transparent;
      }

      .stub {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: var(--color-background-bg-secondary);
          border-radius: 50%;
          color: var(--color-content-content-secondary);
          position: relative;
      }
      .stub-loader {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid;
          border-bottom-color: var(--secondary);
          border-top-color: var(--secondary);
          animation: spin 1s linear infinite;
      }
      
      img {
          user-select: none;
          outline: none;
          -webkit-user-select: none;
          -webkit-tap-highlight-color: transparent;
      }

      @keyframes spin {
          0% {
              transform: rotate(0deg);
          }

          100% {
              transform: rotate(360deg);
          }
      }
  
  `;
__decorateClass([
  property({ type: String, attribute: true })
], TokenIconElement.prototype, "symbol", 2);
__decorateClass([
  property({ type: String, attribute: true })
], TokenIconElement.prototype, "address", 2);
__decorateClass([
  property({ type: Number, attribute: true })
], TokenIconElement.prototype, "chainId", 2);
__decorateClass([
  property({ type: Number, attribute: true })
], TokenIconElement.prototype, "size", 2);
__decorateClass([
  consume({ context: ApplicationContextToken })
], TokenIconElement.prototype, "applicationContext", 2);
TokenIconElement = __decorateClass([
  customElement(TokenIconElement.tagName)
], TokenIconElement);
function symbolView(size, symbol, showLoader) {
  return html`
    <div style="width: ${size}px; height: ${size}px; font-size: ${size < 40 ? 13 : 16}px" class="stub">
      <span>${symbol?.slice(0, size < 40 ? 1 : 2) ?? ""}</span>
      ${showLoader ? html`<span class="stub-loader"></span>` : ""}
    </div>
  `;
}
async function loadFromRepository(data, index = 0) {
  const repositoryLoader = repositories[index];
  if (!repositoryLoader) return null;
  try {
    const repository = await repositoryLoader();
    return await repository(data);
  } catch (error) {
    return await loadFromRepository(data, index + 1);
  }
}
export {
  TokenIconElement
};
//# sourceMappingURL=index.esm.js.map
